var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSuggestedRedactionTermsFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 104,
    viewBox: "0 0 125 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_17860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.82 17.9697V11.0397C85.82 6.57973 82.21 2.96973 77.75 2.96973H10.82C6.36 2.96973 2.75 6.57973 2.75 11.0397V66.4297C2.75 70.8897 6.36 74.4997 10.82 74.4997H30.44",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.55 2.96973H115.24C119.38 2.96973 122.74 6.32973 122.74 10.4697C122.74 14.6097 119.38 17.9697 115.24 17.9697H102.55C98.4098 17.9697 95.0498 14.6097 95.0498 10.4697C95.0498 6.32973 98.4098 2.96973 102.55 2.96973Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 83.7393H22.94C27.08 83.7393 30.44 87.0993 30.44 91.2393C30.44 95.3793 27.08 98.7393 22.94 98.7393H10.25C6.11 98.7393 2.75 95.3793 2.75 91.2393C2.75 87.0993 6.11 83.7393 10.25 83.7393Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5599 64.5298C87.5799 55.3698 86.5699 42.9498 78.5099 34.8898C69.2999 25.6798 54.3599 25.6698 45.1399 34.8898C35.9299 44.0998 35.9299 59.0498 45.1399 68.2598C53.1999 76.3198 65.6299 77.3298 74.7799 71.3098",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8104 61.5995C46.2804 56.0595 46.2704 47.0895 51.8104 41.5495C57.3504 36.0095 66.3204 36.0095 71.8604 41.5495",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9102 64.9795L90.7802 73.8495C91.9402 75.0095 93.6202 75.2095 94.5302 74.2995C95.4402 73.3895 97.1202 73.5895 98.2802 74.7495L111.62 88.0895C112.78 89.2495 112.98 90.9295 112.07 91.8395L107.76 96.1495",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3203 75.0195L85.4603 79.1595C86.6203 80.3295 86.8203 82.0095 85.9203 82.9095C85.4603 83.3695 85.2903 84.0095 85.3603 84.6895C85.4403 85.3695 85.7903 86.0795 86.3703 86.6595L99.7103 99.9995C100.87 101.17 102.56 101.36 103.46 100.45L107.77 96.1395",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_17860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.5,
    height: 103.06,
    fill: "white",
    transform: "translate(0.25 0.469727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSuggestedRedactionTermsFound);
export default __webpack_public_path__ + "static/media/no-suggested-redaction-terms-found.d08341fbb7de02013755f47d342d7115.svg";
export { ForwardRef as ReactComponent };